/* Copyright (c) 2023 TORITI */

import Request from './request';

export default class SmsWalletService {
  // ==================== MERCHANT APIs ====================

  static async getMerchantWallet(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'merchant/sms-wallet',
        query
      }).then((result = {}) => {
        console.log('Merchant SMS Wallet response:', result);

        if (result.success && result.data) {
          return resolve({
            success: true,
            balance_segments: result.data.balance_segments || 0,
            data: result.data.items || [],
            pagination: result.pagination || {
              page: query.page || 1,
              page_size: result.data.page_size || 10,
              total_items: result.data.total_items || 0,
              total_pages: result.data.total_pages || 0
            },
            message: result.message
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Merchant SMS Wallet error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to fetch SMS wallet' }]
        });
      });
    });
  }

  static async submitTopupRequest(segments) {
    return new Promise((resolve) => {
      console.log(`Submitting top-up request for ${segments} segments`);

      Request.send({
        method: 'POST',
        path: 'merchant/sms-wallet/requests',
        data: { segments }
      }).then((result = {}) => {
        console.log('Submit top-up request response:', result);

        if (result.success) {
          return resolve({
            success: true,
            data: result.data,
            message: result.message || 'Top-up request submitted successfully'
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Submit top-up request error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to submit top-up request' }]
        });
      });
    });
  }

  // ==================== ADMIN APIs ====================

  static async getAdminList(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'admin/sms-wallet/transactions',
        query
      }).then((result = {}) => {
        console.log('SMS Wallet admin list response:', result);

        if (result.success && result.data) {
          return resolve({
            success: true,
            data: result.data.items || result.data,
            pagination: result.pagination || {
              page: query.page || 1,
              pageSize: query.pageSize || 10,
              totalItems: result.data.total_items || 0,
              totalPages: result.data.total_pages || 0
            },
            message: result.message
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('SMS Wallet admin list error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to fetch SMS wallet transactions' }]
        });
      });
    });
  }

  static async approveTopup(transactionId) {
    return new Promise((resolve) => {
      console.log(`Approving SMS wallet top-up transaction: ${transactionId}`);

      Request.send({
        method: 'PUT',
        path: `admin/sms-wallet/transactions/${transactionId}/approve`
      }).then((result = {}) => {
        console.log('Approve transaction response:', result);

        if (result.success) {
          return resolve({
            success: true,
            data: result.data,
            message: result.message || 'Transaction approved successfully'
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Approve transaction error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to approve transaction' }]
        });
      });
    });
  }

  static async rejectTopup(transactionId, reason = '') {
    return new Promise((resolve) => {
      console.log(`Rejecting SMS wallet top-up transaction: ${transactionId}`);

      Request.send({
        method: 'PUT',
        path: `admin/sms-wallet/transactions/${transactionId}/reject`,
        data: { reason }
      }).then((result = {}) => {
        console.log('Reject transaction response:', result);

        if (result.success) {
          return resolve({
            success: true,
            data: result.data,
            message: result.message || 'Transaction rejected successfully'
          });
        }

        return resolve(result);
      }).catch((error) => {
        console.error('Reject transaction error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to reject transaction' }]
        });
      });
    });
  }

  static async getTransactionById(transactionId) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: `admin/sms-wallet/transactions/${transactionId}`
      }).then((result = {}) => {
        console.log('Transaction detail response:', result);
        return resolve(result);
      }).catch((error) => {
        console.error('Transaction detail error:', error);
        return resolve({
          success: false,
          errors: [{ message: error.message || 'Failed to fetch transaction details' }]
        });
      });
    });
  }
}
